/**
 * Теги материала на сайте.
 *
 * Тег заменил рубрику: их может быть несколько, и порядок значим — цвет
 * обложки и бейджа берётся от первого. Здесь одно место, где это правило
 * записано: карточка, лента топа и страница статьи красятся одинаково, и
 * разъехаться им негде.
 */

export type BlogTag = {
  title: string
  /** Название для /en. Пусто — покажем русское: метка без перевода понятнее пустоты. */
  titleEn?: string | null
  slug: string
  color: string | null
}

/** Запасной цвет: у тега, которому цвет не выбрали, обложка не должна быть чёрной. */
const FALLBACK = '#8944EB'

export const blogTagColor = (tags?: BlogTag[] | null): string =>
  tags?.[0]?.color?.trim() || FALLBACK

/**
 * Подпись тега под текущий язык.
 *
 * Перевод задаётся в админке и часто отстаёт от новых тем, поэтому пустое
 * значение — не ошибка: показываем русское название, а не пустой бейдж.
 */
export const blogTagTitle = (tag: BlogTag | null | undefined, locale: string): string => {
  if (!tag) return ''

  return locale === 'en' ? (tag.titleEn?.trim() || tag.title) : tag.title
}

/** Первый тег — тот, что задаёт цвет и стоит бейджем на обложке. */
export const blogPrimaryTag = (tags?: BlogTag[] | null): BlogTag | null => tags?.[0] ?? null

/** Остальные теги: показываем подписями без цвета. */
export const blogRestTags = (tags?: BlogTag[] | null): BlogTag[] => (tags ?? []).slice(1)
